import { Button, Chip, Stack, Typography, styled } from "@mui/material";
import { ArrowRightIcon } from "@phosphor-icons/react/dist/csr/ArrowRight";
import { useNavigate } from "react-router-dom";
import { DownloadsSummaryPanel } from "../../../components";
import { useAccountContext } from "../../../strict/app/AccountResolver";

const CardContainer = styled("div")(({ theme }) => ({
  minWidth: "550px",
  boxShadow: theme.mixins.shadowSurfaceLight10,
  ...theme.applyStyles("dark", {
    boxShadow: theme.mixins.shadowSurfaceDark10,
  }),
  background: theme.palette.surfaceLight10.main,
  padding: "28px 32px 51px 32px",
  borderRadius: "8px",
  border: `1px solid ${theme.palette.surfaceLight30.main}`,
}));

const DownloadsSummaryHome = ({ csOnly }: { csOnly: boolean }) => {
  const { urlName } = useAccountContext();

  const navigate = useNavigate();
  return (
    <CardContainer>
      <Stack direction="row" sx={{ alignItems: "center" }}>
        <Typography variant="heading.four" sx={{ color: "text50.main" }}>
          Downloads Summary
        </Typography>
        <Stack sx={{ ml: "28px" }}>
          <Chip variant="info" label={csOnly ? "CS Only" : "Visible for customer"} />
        </Stack>
        <Stack direction="row" sx={{ ml: "auto", justifyContent: "flex-end" }}>
          <Button
            variant="outlined"
            onClick={() => navigate(`/app/${urlName}/homepage/charts`)}
            endIcon={<ArrowRightIcon />}
          >
            View details
          </Button>
        </Stack>
      </Stack>
      <DownloadsSummaryPanel />
    </CardContainer>
  );
};

export { DownloadsSummaryHome };
